module.exports = __webpack_public_path__ + "images/slide-box-bg.jpg";